import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const StyledMenuCategory = styled(MenuItem)({
    fontSize: "13px",
    fontWeight: 600,
    background: "rgb(240,240,240)",
    color: "rgba(0, 0, 0, 0.87)",
    "& > a:hover": {
        cursor: "default",
    },
});

const StyledMenuSubItem = styled(MenuItem)({
    fontSize: "14px",
    padding: "16px",
});

const LeaseAndSaleDropdownOptions = (props) => {
    const { callback, addConsultingBlock, addNoListingText, property } = props;
    const handleNewTransaction = (spaceUse, transactionType) => {
        if (property) {
            callback(property, spaceUse, transactionType);
        } else {
            callback(spaceUse, transactionType);
        }
    };

    return (
        <React.Fragment>
            {addConsultingBlock && (
                <React.Fragment>
                    <StyledMenuCategory disabled disableAutoFocusItem>
                        Consulting (No Listing)
                    </StyledMenuCategory>
                    <StyledMenuSubItem onClick={() => handleNewTransaction(null, "Consulting")}>
                        Consulting Deal
                    </StyledMenuSubItem>
                </React.Fragment>
            )}
            <StyledMenuCategory disabled disableAutoFocusItem>
                {addNoListingText ? "Lease (No Listing)" : "Lease"}
            </StyledMenuCategory>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Office", "Lease")}>Office Lease</StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Industrial", "Lease")}>
                Industrial Lease
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Retail", "Lease")}>Retail Lease</StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Land", "Lease")}>Land Lease</StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Multifamily", "Lease")}>
                Multifamily Lease
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Life Science", "Lease")}>
                Life Science Lease
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Healthcare", "Lease")}>
                Healthcare Lease
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Religious", "Lease")}>
                Religious Lease
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Educational", "Lease")}>
                Educational Lease
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Other", "Lease")}>Other Lease</StyledMenuSubItem>
            <StyledMenuCategory disabled disableAutoFocusItem>
                {addNoListingText ? "Sale (No Listing)" : "Sale"}
            </StyledMenuCategory>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Office", "Sale")}>Office Sale</StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Industrial", "Sale")}>
                Industrial Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Retail", "Sale")}>Retail Sale</StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Land", "Sale")}>Land Sale</StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Hospitality", "Sale")}>
                Hospitality Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Multifamily", "Sale")}>
                Multifamily Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Life Science", "Sale")}>
                Life Science Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Healthcare", "Sale")}>
                Healthcare Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Religious", "Sale")}>
                Religious Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Educational", "Sale")}>
                Educational Sale
            </StyledMenuSubItem>
            <StyledMenuSubItem onClick={() => handleNewTransaction("Other", "Sale")}>Other Sale</StyledMenuSubItem>
        </React.Fragment>
    );
};

export default LeaseAndSaleDropdownOptions;
